// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PyV8","top":"styles_top__1ccce"};